import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=85e76c2c&scoped=true&"
import script from "./VideoList.vue?vue&type=script&lang=ts&"
export * from "./VideoList.vue?vue&type=script&lang=ts&"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=85e76c2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e76c2c",
  null
  
)

export default component.exports